import base from '../dr-base'
import drHtml from './dr-html.vue'

const schema = {
  $Type: 'dr-html',
  name: 'Html',
  group: 'Advanced',
  icon: 'file-code',
  ...base,
  properties: {
    ...base.properties,
    Html: {
      name: 'vuetifyWidgets.dr-html.html',
      type: 'string'
    }
  }
}

export default {
  schema,
  component: drHtml
}
